// src/components/AppModal/AppModal.tsx
import React, { FC, ReactNode } from 'react';
import { Modal } from 'antd';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import classes from './AppModal.module.less';
import closeIcon from '../../assets/icons/x.svg';

type AppModalProps = {
  title?: ReactNode;
  visible?: boolean;
  onCancel?: () => void;
  // Okienka z listami (udostępnianie, grupy) potrzebują więcej miejsca
  wide?: boolean;
  // Szerokość okienka, któremu nie wystarcza ani zwykłe 440px, ani 540px z `wide` — ma pierwszeństwo przed `wide`
  width?: number;
  // Własne style treści okienka
  className?: string;
};

// Okienko aplikacji w pomarańczowej przerywanej ramce: tytuł i krzyżyk na morskim pasku, pod nim srebrna obwódka
// z wpuszczonym w nią panelem treści. Przyciski na dole podaje okienko w <ModalButtons>. Szerokość razem z obwódką,
// o 20px większa niż przed obwódką — treść ma tyle miejsca co na dawnym płótnie, które wychodziło 10px poza okienko
const AppModal: FC<AppModalProps> = ({
  title, visible = true, onCancel, wide, width, className, children,
}) => {
  const { t } = useTranslation();

  return (
    <Modal
      className={classNames(classes.modal, className)}
      title={title}
      width={width ?? (wide ? 540 : 440)}
      footer={null}
      visible={visible}
      onCancel={onCancel}
      destroyOnClose
      centered
      closeIcon={<img src={closeIcon} alt={t('common:buttons.close')} />}
    >
      {children}
    </Modal>
  );
};

// Rząd przycisków na dole okienka, po równo na całą szerokość
export const ModalButtons: FC = ({ children }) => <div className={classes.buttons}>{children}</div>;

export default AppModal;
